import styled from 'styled-components';

export const ErrorMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  margin-top: 2rem;
`;
